"use strict";

var cov_1nddsv0vv5 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\VerseObjects.js";
  var hash = "be3a4f87efb259b5e153692f07153bf2ebaa60cb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\VerseObjects.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 28
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 32
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "2": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 20,
          column: 6
        }
      },
      "3": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 4
        }
      },
      "4": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 38,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 28
          },
          end: {
            line: 6,
            column: 29
          }
        },
        loc: {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 49
          },
          end: {
            line: 13,
            column: 50
          }
        },
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 20,
            column: 6
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "be3a4f87efb259b5e153692f07153bf2ebaa60cb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VerseObjects = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require(".");

cov_1nddsv0vv5.s[0]++;

var VerseObjects = function VerseObjects(_ref) {
  var verseObjects = _ref.verseObjects,
      paragraphs = _ref.paragraphs,
      showUnsupported = _ref.showUnsupported,
      disableWordPopover = _ref.disableWordPopover;
  cov_1nddsv0vv5.f[0]++;
  var verseObjectComponents = (cov_1nddsv0vv5.s[1]++, verseObjects.map(function (verseObject, index) {
    cov_1nddsv0vv5.f[1]++;
    cov_1nddsv0vv5.s[2]++;
    return _react.default.createElement(_.VerseObject, {
      key: index,
      verseObject: verseObject,
      paragraphs: paragraphs,
      showUnsupported: showUnsupported,
      disableWordPopover: disableWordPopover
    });
  }));
  cov_1nddsv0vv5.s[3]++;
  return _react.default.createElement(_react.default.Fragment, null, verseObjectComponents);
};

exports.VerseObjects = VerseObjects;
cov_1nddsv0vv5.s[4]++;
VerseObjects.propTypes = {
  verseObjects: _propTypes.default.array.isRequired,

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var _default = VerseObjects;
exports.default = _default;